import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireFeature } from '@/features/authentication';
import { RFQ_FEATURE } from '@/features/bids';
import { LazyLoad } from '@/shared/components/LazyLoad';
import { SupplierDashboardGate } from './components/SupplierDashboardGate';
import { SUPPLIER_BID_FEATURE } from '../supplier-quotation/common/models/supplierQuotation.constants';

const SupplierDashboardPage = lazy(() => import('./pages/SupplierDashboardPage'));

/**
 * The Supplier Dashboard (2026-10-29, NB-637). A relative path: `app/routes/protectedRoutes.tsx` nests it inside the
 * shell. Open to the Supplier role alone, and -- as the supplier's BID screens -- behind BIDs in RBAC and Supplier Bid,
 * the feature its endpoints are guarded by.
 */
export const supplierDashboardRoutes: RouteObject[] = [
  {
    path: 'supplier-dashboard',
    element: <SupplierDashboardGate />,
    children: [
      {
        index: true,
        element: (
          <RequireFeature feature={RFQ_FEATURE}>
            <RequireFeature feature={SUPPLIER_BID_FEATURE}>
              <LazyLoad>
                <SupplierDashboardPage />
              </LazyLoad>
            </RequireFeature>
          </RequireFeature>
        ),
      },
    ],
  },
];
